const COOKIE_ACKNOWLEDGEMENT_STORAGE_KEY = 'userAcknowledgesCookieUse';

export default COOKIE_ACKNOWLEDGEMENT_STORAGE_KEY;
